//--------------------------------------------
//
// Collection of photos for timeline
//
//--------------------------------------------

export default [
	{
		message: 'Soooo... my dad used to play the saxophone',
		image: 'img/timeline/sax_dad.jpg'
	},
	{
		message: 'Wow, great RL Stine collection at the Lindenhurst library!',
		image: 'img/timeline/library.jpg'
	},
	{
		message: 'Over at Schneider’s again...',
		image: 'img/timeline/guinea.JPG'
	},
	{
		message: 'Hey girl',
		image: 'img/timeline/lizard.jpg'
	},
	{
		message: 'Hi, it’s me, your mom. please contact me.',
		image: 'img/timeline/mom.jpg'
	},
	{
		message: 'The results are in and Brett has made the cast!',
		image: 'img/timeline/meeting.jpg'
	},
	{
		message: 'Kim on lunch break again. #salad',
		image: 'img/timeline/salad.jpg'
	},
	{
		message: 'Love playing for my parents. Thanks for raising me!',
		image: 'img/timeline/sax_teen.jpg'
	},
	{
		message: 'Playing this Friday 7-9pm at McShane’s Bistro. Mention DJ Tanner for 50% off first appetizer.',
		image: 'img/timeline/dj.jpg'
	},
	{
		message: 'hey remember me from highschool! i’m in town for the weekend! let’s get some brewskis!',
		image: 'img/timeline/brew.jpg'
	},
	{
		message: 'PHOTOGRAPHY IS MY LIFE!',
		image: 'img/timeline/dancer.jpg'
	},
	{
		message: 'finally getting engaged you guys!',
		image: 'img/timeline/party.jpg'
	},
	{
		message: 'hi you still owe us 4 hours of volunteering at the co op',
		image: 'img/timeline/coop.jpg'
	}
]